export const FEEDBACK = 'feedback/'
export const FEEDBACK_ALL = `${FEEDBACK}all`
export const FEEDBACK_EDIT = `${FEEDBACK}edit`
export const FEEDBACK_STATUS = `${FEEDBACK}status/`
export const FEEDBACK_TYPES = `${FEEDBACK}types`
export const FEEDBACK_UPDATE = `${FEEDBACK}update`

export const FEEDBACK_FORM = 'feedback_form/'
export const FEEDBACK_FORM_ALL = `${FEEDBACK_FORM}all`
